<template>
	<div class="tickets">
		<div class="ticket-section">{{ config.ticketHeaderText }}</div>
		<div
			v-for="(ticket, index) in options"
			v-bind:key="ticket.name"
			v-on:click="
				selectedTicketIndex = index;
				selectedTicketQuantity = 1;
				selectedAddonIndex = -1;
			"
			:class="index === selectedTicketIndex ? 'ticket selected' : 'ticket'"
		>
			<div class="ticket-header">
				<div class="ticket-title">
					<h3><b-radio :value="index" name="selectedTicketIndex" v-model="selectedTicketIndex" /> {{ ticket.name }}</h3>
					<p>{{ ticket.price.currency.toUpperCase() }} ${{ (ticket.price.unit_amount / 100).toFixed(2) }}</p>
				</div>

				<div class="ticket-quantity">
					<div v-if="selectedTicketIndex === index && ticket.maximum > 1">
						<b-input-group size="sm" class="quantity-input-group">
							<b-input-group-prepend>
								<b-button
									:disabled="selectedTicketQuantity == 1"
									variant="outline-secondary"
									size="sm"
									v-on:click.stop="selectedTicketQuantity--"
									>-</b-button
								>
							</b-input-group-prepend>
							<b-form-input readonly name="selectedTicketQuantity" v-model="selectedTicketQuantity"></b-form-input>
							<b-input-group-append>
								<b-button
									:disabled="selectedTicketQuantity == ticket.maximum"
									variant="outline-secondary"
									size="sm"
									v-on:click.stop="selectedTicketQuantity = selectedTicketQuantity + 1"
									>+</b-button
								>
							</b-input-group-append>
						</b-input-group>
					</div>
				</div>
			</div>
			<div class="ticket-description" v-html="ticket.description"></div>
			<img :src="ticket.images[0]" v-bind:alt="ticket.name" height="100" v-if="ticket.images.length > 0" />
		</div>

		<div v-show="options[selectedTicketIndex].addons && options[selectedTicketIndex].addons.length > 0">
			<div class="ticket-section">Select an add-on</div>

			<div v-on:click="selectedAddonIndex = -1" :class="-1 === selectedAddonIndex ? 'ticket selected' : 'ticket'">
				<div class="ticket-header">
					<div class="ticket-title">
						<h3><b-radio :value="-1" name="selectedAddonIndex" v-model="selectedAddonIndex" /> No add-on needed</h3>
					</div>

					<div class="ticket-quantity"></div>
				</div>
			</div>
			<div
				v-for="(addon, index) in options[selectedTicketIndex].addons"
				v-bind:key="addon.name"
				v-on:click="
					selectedAddonIndex = index;
					selectedAddonQuantity = 1;
				"
				:class="index === selectedAddonIndex ? 'ticket selected' : 'ticket'"
			>
				<div class="ticket-header">
					<div class="ticket-title">
						<h3><b-radio :value="index" name="selectedAddonIndex" v-model="selectedAddonIndex" /> {{ addon.name }}</h3>
						<p>{{ addon.price.currency.toUpperCase() }} ${{ (addon.price.unit_amount / 100).toFixed(2) }}</p>
					</div>

					<div class="ticket-quantity">
						<div v-if="selectedAddonIndex == index && addon.maximum > 1">
							<b-input-group size="sm" class="quantity-input-group">
								<b-input-group-prepend>
									<b-button
										:disabled="selectedAddonQuantity == 1"
										variant="outline-secondary"
										size="sm"
										v-on:click.stop="selectedAddonQuantity--"
										>-</b-button
									>
								</b-input-group-prepend>
								<b-form-input readonly name="selectedAddonQuantity" v-model="selectedAddonQuantity"></b-form-input>
								<b-input-group-append>
									<b-button
										:disabled="selectedAddonQuantity == addon.maximum"
										variant="outline-secondary"
										size="sm"
										v-on:click.stop="selectedAddonQuantity++"
										>+</b-button
									>
								</b-input-group-append>
							</b-input-group>
						</div>
					</div>
				</div>
				<div class="ticket-description" v-html="addon.description"></div>
				<img :src="addon.images[0]" v-bind:alt="addon.name" height="100" v-if="addon.images.length > 0" />
			</div>
		</div>
		<div class="ticket-section">{{ config.ticketFooterText }}</div>
	</div>
</template>

<script>
import { formatString } from "@/stringutilities";

import { log } from "@/logging";
const myLoggingName = "Tickets";

export default {
	data() {
		return {
			selectedTicketIndex: 0,
			selectedTicketQuantity: 1,
			options: [],
			addons: [],
			selectedAddonIndex: -1,
			selectedAddonQuantity: 1
		};
	},
	props: {
		config: Object
	},
	inject: ["authService", "configService"],
	name: "Tickets",
	computed: {},
	async mounted() {
		this.$emit("loading", true);

		const mode = this.config.mode;

		const paymentApiURL = formatString(this.config.paymentApiTemplate, {
			hostName: this.configService.getHostName().split(".")[0],
			region: this.config.paymentRegion
		});

		this.options = [];

		for (const stripeProduct of this.config.environment[mode].stripeProductIds) {
			const product = await fetch(`${paymentApiURL}/products/${stripeProduct.id}?mode=${mode}`, {
				method: "get",
				headers: {
					"Content-Type": "application/json",
					Authorization: this.authService?.token
				},
				mode: "cors"
			})
				.then(res => res.json())
				.catch(err => {
					log(myLoggingName, "productRetrieve", "errorInRequest", err);
				});

			const option = {
				...product,
				maximum: stripeProduct.maximum,
				addons: []
			};

			for (const addon of stripeProduct.addons) {
				const product = await fetch(`${paymentApiURL}/products/${addon.id}?mode=${mode}`, {
					method: "get",
					headers: {
						"Content-Type": "application/json",
						Authorization: this.authService?.token
					},
					mode: "cors"
				})
					.then(res => res.json())
					.catch(err => {
						log(myLoggingName, "productRetrieve", "errorInRequest", err);
					});

				if (!product) continue;
				option.addons.push({
					...product,
					maximum: addon.maximum
				});
			}

			if (!product) continue;
			this.options.push(option);
		}

		this.$emit("loading", false);
	},
	methods: {}
};
</script>

<style scoped lang="scss">
@import "../../scss/constants";

.tickets {
	margin-bottom: 32px;

	.ticket-section {
		border-bottom: 1px dashed lightgray;
		margin: 16px 0;
		padding: 4px;
		font-size: 1.2rem;
	}

	.ticket {
		border-radius: 8px;
		border: 2px solid #ddd;
		padding: 16px;
		margin: 0 0 12px 0;
		text-align: left;
		cursor: pointer;

		&.selected {
			border: 2px solid var(--primary);
		}

		.ticket-header {
			display: flex;
			flex-direction: row;

			.ticket-title {
				flex-grow: 1;

				h3 {
					font-size: 1.1rem;
					margin-bottom: 0;
					line-height: 1.5rem;

					.custom-control {
						display: inline-block;
					}
				}

				p {
					font-size: 1rem;
					margin-top: 4px;
				}
			}

			.ticket-quantity {
				text-align: right;
				width: 80px;

				.quantity-input-group {
					border-color: 1px solid var(--primary);

					input {
						width: 20px;
						padding: 4px;
						text-align: center;
						background: white;
						border-color: 1px solid var(--secondary);
					}

					button {
						width: 22px;
						text-align: center;
						font-size: 12px;
						font-weight: bold;
						padding: 0;
					}
				}
			}
		}
	}
}
</style>
